module.exports = __webpack_public_path__ + "media/images/user/cross-fbd10526efcc2979d12e71c8b10fad04.svg";